skrilla.directive('userSportsExclusions', function () {
    return {
        templateUrl: 'directives/userSportsExclusions/userSportsExclusions.html',
        scope: {
            user: "="
        },
        controller: async function ($scope, searchService, queryService, srefService, cacheService, modalService,
                                    sportService, adminService, userExclusionsService, validationService) {
            $scope.hasRole = adminService.hasRole
            $scope.effectiveUntilColour = userExclusionsService.getEffectiveUntilColour
            $scope.sports = await sportService.getSports()
            $scope.pageKey = "sportsExclusions";
            $scope.reset = function () {
                $scope.query = {
                    limit: 20,
                }};
            $scope.reset()

            $scope.search = function() {
                 searchService.get("sportsExclusions/user/" + $scope.user.id).then(function(response) {
                    $scope.exclusions = response.data;
                });
            }

            $scope.findMatchingPersons = function () {
                searchService.get("excludedPersonsRegister/looksLikeUser/" + $scope.user.id).then(function(response) {
                    $scope.persons = response.data;
                });
            }
            $scope.findMatchingPersons()

            $scope.linkPersonToUser = function (person) {
                if (person.exclusionType === 'PRODUCT') {
                    modalService.error("You cannot currently link PRODUCT-excluded persons to users.", function () {
                        modalService.dismissAll()
                    });
                } else if (person.id === $scope.user.excludedPersonId) {
                    modalService.error("This person is already linked to the current user.", function () {
                        modalService.dismissAll()
                    });
                } else {
                    modalService.confirm("Are you sure you'd like to link this person to this user? " +
                            "If another person is already linked, they will be removed " +
                                "and replace with this person if you continue.", function () {
                        searchService.put(`users/${$scope.user.id}/linkToExcludedPerson`, {personId: person.id},
                            "Excluded person has been linked to this user").then(function (response) {
                            $scope.search()
                            $scope.user.excludedPersonId = person.id
                        });
                    });
                }
            }

            $scope.openExcludedPersonsModal = function(excludedPersonId) {
                let person = {}
                searchService.get("excludedPersonsRegister/" + excludedPersonId).then(function(response) {
                    person = response.data;
                    cacheService.registerObject("excludedUsers", person);
                    if (validationService.isNotEmpty(person)) {
                        modalService.openModal("views/excludedPersons/excludedPersonsModal.html", true, 'lg', true, true, function() {

                        })
                    }
                });
            }

            $scope.search()
        }
    };

});